module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-piso-7683fb04681b1bc3e3f0bc9c51aeb2f2.jpg";